<div class="avatar-wrapper" *cmLet="(imageLoading$ | async) as imageLoading">
    <div *ngIf="!imageLoading; else spinner">
        <span
            *ngIf="!canUpdateAvatar || (canUpdateAvatar && !profile.avatar?.imageFile); else avatarImage"
            (click)="openUploadModal()"
        >
            <cm-profile-avatar
                class="avatar avatar-uploaded"
                [imageUrl]="profile.avatar?.imageFile || profile.image"
                [placeholder]="profileAvatarPlaceholder"
            ></cm-profile-avatar>
        </span>
        <ng-template #avatarImage>
            <cm-profile-avatar
                [imageUrl]="profile.avatar.imageFile"
                class="avatar avatar-uploaded"
                alt="Profile logo"
            ></cm-profile-avatar>
        </ng-template>
    </div>
    <ng-template #spinner> <cm-spinner class="spinner"></cm-spinner> </ng-template>
    <div *ngIf="canUpdateAvatar && !imageLoading" class="avatar-toolbar">
        <button
            [disabled]="!profile.avatar?.imageFile"
            *ngIf="(isEditAvailable$ | async)"
            class="toolbar-button"
            (click)="onEditLogoClick()"
            ngbTooltip="Edit"
            placement="bottom"
        >
            <cm-icon class="toolbar-icon" name="edit"></cm-icon>
        </button>
        <button class="toolbar-button" (click)="openUploadModal()" ngbTooltip="Upload" placement="bottom">
            <cm-icon class="toolbar-icon" name="upload-arrow"></cm-icon>
        </button>
    </div>
</div>
